export const VENUE_UUID = "5c7ab04d-c01f-47db-96e5-6701ecc3095c"